<template>
  <div class="slideshow">
    <transition name="fade">
      <div class="stage">
        <img src="/assets/venue-1.png" />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="talk" class="content">
        <img :src="talk.image" />
        <img :src="talk.image" class="reflected-image" />
        <em class="fadeout"></em>

        <div class="details">
          <h2>
            {{ talk.title || "KEIN TITEL" }}
            <br />
            <small>Bergrettungstag {{ talk.year || "KEIN JAHR" }}</small>
          </h2>
          <p></p>

          <template v-if="talk.speakers.length > 1 || talk.speakerImages.length > 0">
            <p>
              Webinar am
              <strong>{{ talk.localDate || "KEIN DATUM" }}</strong>
              um
              <strong>{{ talk.time || "KEINE UHRZEIT" }} Uhr</strong>
              mit:
            </p>
            <ul v-if="talk.speakerImages.length > 0" class="speaker-list">
              <li v-for="(speaker, index) in talk.speakers" :key="index">
                <img v-if="speaker.image" :src="speaker.image" />
                {{ speaker.name }}
              </li>
            </ul>
            <ul v-else>
              <li v-for="(speaker, index) in talk.speakers" :key="index">{{ speaker.name }}</li>
            </ul>
          </template>
          <p v-else>
            Webinar am
            <strong>{{ talk.localDate || "KEIN DATUM" }}</strong>
            um
            <strong>{{ talk.time || "KEINE UHRZEIT" }} Uhr</strong>
            mit:
            <br />
            {{ talk.speakerNames.join(", ") || "—" }}
          </p>

          <template v-if="talk.homepage && talk.homepage != ''">
            <h4>Homepage</h4>

            <p>
              <a :href="talk.homepage" target="_new">{{ talk.homepage }}</a>
            </p>
          </template>

          <p v-if="talk.zoom && !talk.pastEvent">
            <strong>Zoom-Konferenz:</strong>
            <br />
            <a
              v-if="talk.zoom != ''"
              :href="talk.zoom"
              target="_new"
              class="shortened-link"
            >{{ talk.zoom }}</a>
            <span v-else>Noch nicht verfügbar</span>
          </p>

          <p v-if="talk.youtube">
            <strong>Youtube:</strong>
            <br />
            <a
              v-if="talk.youtube != ''"
              :href="talk.youtube"
              target="_new"
              class="shortened-link"
            >{{ talk.youtube }}</a>
            <span v-else>Noch nicht verfügbar</span>
          </p>

          <p v-if="talk.description && talk.description != ''">
            <vue-markdown :content="talk.description"></vue-markdown>
          </p>

          <router-link class="backlink" to="/talks">Zurück</router-link>
        </div>
      </div>

      <div v-else class="content">
        <img src="/assets/venue-2.png" />
        <img src="/assets/venue-2.png" class="reflected-image" />

        <div class="details">
          <h3>Huch?! Diese Veranstaltung gibt es nicht…</h3>

          <router-link class="backlink" to="/talks">Zurück</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MarkdownItVue from "markdown-it-vue";

export default {
  name: "Talk",

  components: {
    "vue-markdown": MarkdownItVue,
  },

  props: {
    msg: String,
  },

  data() {
    return {};
  },

  computed: {
    id() {
      return this.$route.params.id;
    },

    talk() {
      return this.$_talk(this.id);
    },
  },

  watch: {
    id(to, from) {
      console.log(`Opening talk from ${from || "—"} to ${to}`);
    },
  },
};
</script>

<style scoped>
.details {
  color: #fff;
  padding-left: 1em !important;
  padding-right: 1em !important;
  width: 50% !important;
  overflow: hidden;
  background: rgb(1, 1, 1, 0.6);
  min-height: 880px;
}

.shortened-link {
  display: inline-block;
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.speaker-list {
  list-style-type: none;
  list-style-position: inside;
  padding-left: 0;
}
.speaker-list img {
  float: left;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  width: 3.05em;
}
.speaker-list li,
p {
  clear: both;
}

@media screen and (max-width: 630px) {
  .details {
    width: 70% !important;
  }
}
</style>
